import administrativeCenter from "../../api/administrativeCenter";

const state = {
    rolesList: {},
    roleListLoading: false,
    rolesDetail: {},
    rolePermissionTree: {},

    tenantDepartmentList: {},
    tenantDepartmentListLoading: false,
    tenantDepartmentDetail: {},

    tenantDepartmentUserList: {},
    tenantDepartmentUserFilter: {},
    tenantDepartmentUserListLoading: false,
    tenantDepartmentUserDetail: {},

    tenantTraineeList: {},
    tenantTraineeFilter: {},
    tenantTraineeListLoading: false,

    lessonLearningList: {size: 20},
    lessonLearningFilter: {},
    lessonLearningListLoading: false,
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    clearFilter(state) {
        state.tenantDepartmentUserFilter = {};
    },
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async getRoles({commit}) {
        commit("setData", {key: "roleListLoading", value: true});
        const res = await administrativeCenter.getUserRoles();
        commit("setData", {key: "rolesList", value: res});
        commit("setData", {key: "roleListLoading", value: false});
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteRole({}, payload) {
        await administrativeCenter.deleteRole(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveRole({}, payload) {
        await administrativeCenter.saveRole(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getRoleById({commit}, payload) {
        const res = await administrativeCenter.getRoleById(payload);
        commit("setData", {key: "rolesDetail", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async getRolePermissionTree({commit}, payload) {
        const res = await administrativeCenter.getRolePermissionTree(payload.id);
        commit("setData", {key: "rolePermissionTree", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async updateRolePermission({commit}, payload) {
        await administrativeCenter.updateRolePermission(payload.id, payload.code, payload.add);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTenantDepartments({commit}, payload) {
        commit("setData", {key: "tenantDepartmentListLoading", value: true});
        const res = await administrativeCenter.getTenantDepartments(payload);
        commit("setData", {key: "tenantDepartmentList", value: res});
        commit("setData", {key: "tenantDepartmentListLoading", value: false});
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteTenantDepartments({}, payload) {
        await administrativeCenter.deleteTenantDepartments(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTenantDepartment({}, payload) {
        await administrativeCenter.saveTenantDepartment(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTenantDepartmentById({commit}, payload) {
        const res = await administrativeCenter.getTenantDepartmentById(payload);
        commit("setData", {key: "tenantDepartmentDetail", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async getTenantDepartmentUser({commit}, payload) {
        commit("setData", {key: "tenantDepartmentUserListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                ...state.tenantDepartmentUserFilter,
                ...payload,
            };
            const res = await administrativeCenter.tenantDepartmentUser.getList(
                params
            );
            commit("setData", {key: "tenantDepartmentUserList", value: res.data});
        } finally {
            commit("setData", {
                key: "tenantDepartmentUserListLoading",
                value: false,
            });
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteTenantDepartmentUser({}, payload) {
        await administrativeCenter.deleteTenantDepartmentUser(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async enableTenantDepartmentUser({}, payload) {
        await administrativeCenter.enableTenantDepartmentUser(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTenantDepartmentUser({}, payload) {
        await administrativeCenter.saveTenantDepartmentUser(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTenantDepartmentUserById({commit}, payload) {
        const res = await administrativeCenter.getTenantDepartmentUserById(payload);
        commit("setData", {key: "tenantDepartmentUserDetail", value: res.data});
    },
    // eslint-disable-next-line no-empty-pattern
    async getTenantTraineeList({commit}, payload) {
        commit("setData", {key: "tenantTraineeListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                ...state.tenantTraineeFilter,
                ...payload,
            };
            const res = await administrativeCenter.getTenantTraineeList.getList(params);
            commit("setData", {key: "tenantTraineeList", value: res.data});
        } finally {
            commit("setData", {
                key: "tenantTraineeListLoading",
                value: false,
            });
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTenantTrainee({commit}, payload) {
        return await administrativeCenter.saveTenantTrainee(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteTenantTrainee({commit}, id) {
        return await administrativeCenter.deleteTenantTrainee({id});
    },
    // eslint-disable-next-line no-empty-pattern
    async getLearningInfoList({commit}, payload) {
        commit("setData", {key: "lessonLearningListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                ...state.lessonLearningFilter,
                ...payload,
            };
            const res = await administrativeCenter.getLearningInfoList.getList(params);
            commit("setData", {key: "lessonLearningList", value: res.data});
        } finally {
            commit("setData", {
                key: "lessonLearningListLoading",
                value: false,
            });
        }
    },
    async exportLearningInfo({}, id) {
        return await administrativeCenter.exportLearningInfo(id);
    },
    async importDepartmentUser({}, payload) {
        console.log("store importDepartmentUser")
        await administrativeCenter.importDepartmentUser(payload);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
